export const REGISTER = 'register';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const FORGOT_PASSWORD = 'password/forgot-password';
export const UPDATE_PASSWORD = 'update_password';
export const RESET_PASSWORD = 'password/reset';
export const GET_USER = 'get_user';
export const USER = 'user';
export const VERIFICATION_USER = 'email/verify/';
export const CLIENTS = 'clients';
export const MODELS = 'models';
export const OFFERS = 'offerts';
export const SHARE_OFFER = 'share_offert';
export const GET_SHARED_OFFER = 'get_shared_offert';
export const GET_OFFERS_BY_ACCEPTED_MODELS = 'offert_models_filtered';
export const GET_LOCATIONS = 'model_locations'; // ONLY for GET instance;
export const LOCATIONS = 'locations'; // NOT for GET instance;
export const GET_EVENTS_BY_MODEL_ID = 'model_events';
export const EVENTS = 'events';
export const SHARED_ZIP = 'get_shared_offert_zip';

export const SECURITY_CHECK = 'settings/security_feed';
export const MANUFACTURERS = 'manufacturers';
export const CATEGORIES = 'categories';
export const PRODUCT = 'products';
export const PAYMENTRULES = 'paymentrules';
export const RETURNRULES = 'returnrules';
export const SITES = 'sites';
export const PUBLISH = 'publish';
export const MOVEMENTS = 'movements';
export const SHIPPINGRULES = 'shippingrules';
export const CONDITIONS = 'conditions';
export const USERS = 'users';
export const VENDORS = 'vendors';
export const FORCE_PRODUCT_SYNC = 'operations/force_sync';
